"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var RightService_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightService = void 0;
const getStrategyHelper_helper_1 = require("../../../../helpers/getStrategyHelper/getStrategyHelper.helper");
const executeStrategy_1 = require("../../../../strategies/executeStrategy");
const fetchRoomService_1 = require("../fetchRoomService/fetchRoomService");
const lodash_1 = require("lodash");
const tsyringe_1 = require("tsyringe");
const required_1 = require("../../../../helpers/required/required");
const signerAndDecoderFromPrivateKey_1 = require("../../../../helpers/JWTGeneric/signerAndDecoderFromPrivateKey");
let RightService = RightService_1 = class RightService {
    constructor(fetchRoomService) {
        this.fetchRoomService = fetchRoomService;
        this.proxyWalletAuthorisationStatus = RightService_1.proxyWalletAuthorisationStatus;
        this.isProxyWallet = RightService_1.isProxyWalletAuthorized;
        this.verifyPayloadSignatures = RightService_1.verifyPayloadSignatures;
        /**
         * Can user join section
         * @param {{roomId: string; sectionId: string; address: string}} parameters
         * @returns {Promise<{isAuthorized: boolean; read: StrategiesReturn; write: StrategiesReturn}>}
         */
        this.canJoinSection = (parameters) => __awaiter(this, void 0, void 0, function* () {
            const { roomId, address, sectionId } = parameters;
            required_1.requiredDefined(roomId, 'roomId must be defined');
            required_1.requiredDefined(sectionId, 'sectionId must be defined');
            const [read, write] = yield Promise.all([
                this.canReadSection(parameters),
                this.canWriteSection(parameters)
            ]);
            return {
                isAuthorized: read.isAuthorized,
                read,
                write
            };
        });
        this.canJoinRoom = (parameters) => __awaiter(this, void 0, void 0, function* () {
            const { roomId, address } = parameters;
            required_1.requiredDefined(roomId, 'roomId must be defined');
            const tokenContent = yield this.fetchRoomService.fetchRoom(roomId);
            const strategies = getStrategyHelper_helper_1.getStrategyHelperFactory(tokenContent, [address])
                .getRoomStrategies();
            return executeStrategy_1.executeStrategiesWithCache(strategies);
        });
        this.canWriteSection = (parameters) => __awaiter(this, void 0, void 0, function* () {
            const { roomId, address, sectionId } = parameters;
            required_1.requiredDefined(roomId, 'roomId must be defined');
            required_1.requiredDefined(sectionId, 'sectionId must be defined');
            const tokenContent = yield this.fetchRoomService.fetchRoom(roomId);
            const strategies = getStrategyHelper_helper_1.getStrategyHelperFactory(tokenContent, [address])
                .getSectionWriteStrategies(sectionId);
            return executeStrategy_1.executeStrategiesWithCache(strategies);
        });
        this.canReadSection = (parameters) => __awaiter(this, void 0, void 0, function* () {
            const { roomId, address, sectionId } = parameters;
            required_1.requiredDefined(roomId, 'roomId must be defined');
            required_1.requiredDefined(sectionId, 'sectionId must be defined');
            const tokenContent = yield this.fetchRoomService.fetchRoom(roomId);
            const strategies = getStrategyHelper_helper_1.getStrategyHelperFactory(tokenContent, [address])
                .getSectionReadStrategies(sectionId);
            return executeStrategy_1.executeStrategiesWithCache(strategies);
        });
    }
    /**
     * Verify global signature and jwt signature.
     * It clones payload, delete signature and check signature of that new modified payload
     * @param payload
     * @returns {Promise<boolean>}
     */
    static verifyPayloadSignatures(params) {
        return __awaiter(this, void 0, void 0, function* () {
            required_1.requiredDefined(params, 'params rpc should not be null');
            required_1.requiredDefined(params.signature, 'params.signature rpc payload should not be null');
            const clonedParams = lodash_1.cloneDeep(params);
            const signature = clonedParams.signature;
            delete clonedParams.signature;
            const proxyWalletAddress = signerAndDecoderFromPrivateKey_1.decoder(JSON.stringify(clonedParams), signature);
            return RightService_1.extractBlockchainWalletAddressWhoAuthorizedProxyWallet(params
                .authorizations, proxyWalletAddress);
        });
    }
    /**
     * Get full strategies with description.
     * @param {{roomId: string; address: string}} parameters
     * @returns {Promise<FullRoomStrategies>}
     */
    fullRoomStrategies(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const { roomId, address } = parameters;
            const nftRoomContent = yield this.fetchRoomService.fetchRoom(roomId);
            const sectionIds = nftRoomContent.sections.map(d => d.id);
            const canJoinRoom = yield this.canJoinRoom({ roomId, address });
            const returnObject = {
                roomId,
                sections: {},
                room: canJoinRoom
            };
            yield Promise.all(sectionIds.map(sectionId => this.canJoinSection({ roomId, sectionId, address })
                .then(result => {
                returnObject.sections[sectionId] = result;
            })));
            return returnObject;
        });
    }
};
RightService.proxyWalletAuthorisationStatus = (authorizationsJWT, publicKeyToVerify) => {
    required_1.requiredDefined(authorizationsJWT, 'authorizations should not be null');
    required_1.requiredDefined(publicKeyToVerify, 'publicKeyToVerify  should not be null');
    const authorisationStatus = authorizationsJWT
        .map(authorization => {
        const { payload } = signerAndDecoderFromPrivateKey_1.JWTDecoder(authorization).decode();
        const { iss, sub } = payload;
        const isValid = signerAndDecoderFromPrivateKey_1.JWTDecoder(authorization).verify(iss);
        const isProxyWalletAuthorized = sub.toLowerCase() === publicKeyToVerify.toLowerCase();
        return {
            blockchainWalletAddress: iss,
            proxyWallet: sub,
            isAuthorized: isValid && isProxyWalletAuthorized
        };
    });
    return {
        isAuthorized: authorisationStatus.map(d => d.isAuthorized).includes(false) === false,
        authorizations: authorisationStatus
    };
};
/**
 * Verify if all jwt in authorization correponds to global signing public key
 * @param authorizationsJWT
 * @param publicKeyToVerify
 * @returns {boolean}
 */
RightService.isProxyWalletAuthorized = (authorizationsJWT, publicKeyToVerify) => {
    const authorisationStatus = RightService_1.proxyWalletAuthorisationStatus(authorizationsJWT, publicKeyToVerify);
    return authorisationStatus.isAuthorized;
};
RightService.extractBlockchainWalletAddressWhoAuthorizedProxyWallet = (authorizationsJWT, proxyWalletAddress) => {
    const isAuthorized = RightService_1.isProxyWalletAuthorized(authorizationsJWT, proxyWalletAddress);
    if (isAuthorized) {
        const blockchainWallets = authorizationsJWT
            .map(authorization => signerAndDecoderFromPrivateKey_1.JWTDecoder(authorization).decode().payload.iss);
        return {
            isAuthorized,
            blockchainWallets,
            proxyWalletAddress
        };
    }
    else {
        return {
            isAuthorized,
            blockchainWallets: [],
            proxyWalletAddress
        };
    }
};
RightService = RightService_1 = __decorate([
    tsyringe_1.scoped(tsyringe_1.Lifecycle.ContainerScoped),
    __metadata("design:paramtypes", [fetchRoomService_1.FetchRoomService])
], RightService);
exports.RightService = RightService;
//# sourceMappingURL=rightService.js.map